import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useAuthStore } from '@/js/account/entities/session/model/auth.store';

/** Reactive session state (current user, bootstrap, guards). */
export function useAuth() {
  const store = useAuthStore();
  const { user, needsEmailVerification, bootstrapped, loading }
    = storeToRefs(store);

  const isAuthenticated = computed(
    () => user.value !== null || needsEmailVerification.value,
  );

  const isVerified = computed(() => user.value !== null);

  const isAdmin = computed(() => user.value?.isAdmin === true);

  return {
    user,
    needsEmailVerification,
    bootstrapped,
    loading,
    isAuthenticated,
    isVerified,
    isAdmin,
    fetchMe: store.fetchMe,
    bootstrap: store.bootstrap,
    clearUser: store.clearUser,
  };
}
